import React from "react";
import {Box, Container, Typography} from "@mui/material";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { ReactComponent as CautionIcon } from "../../assests/icons/caution_icon.svg";
import { ErrorToken, homeToken } from "../../utils/constant";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PageNotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
   
  return (
    <Box component={'div'} sx={{height:"75vh",overflow:'auto',padding: "4rem 0 ",marginRight:"0.2rem",marginTop:"0.2rem"}} >
			<Container sx={{width:'83.8%'}} disableGutters>
        <Dialog open={true}> 
         <Box sx={{display:'flex', flexDirection:'column',justifyContent:'center',alignItems:'center',padding:'2.5rem',width:'60rem',overflow:'hidden'}}>
        <Box sx={{display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%', paddingBottom:'0.2rem',borderBottom:'1px solid #c8c8c8'}}>
        <DialogTitle id="responsive-dialog-title" sx={{margin:'auto',padding:'0',fontSize:'2.5rem',color:'#cf2030'}}>
        {t(homeToken.DataNotFound)}
        </DialogTitle>
        {/* <CloseIconRed /> */}
        </Box>
             <Box sx={{display:"flex", gap:"2.5rem", padding:"2.5rem 2rem",justifyContent:'center',alignItems:'flex-start'}}>
              <Box sx={{flex:"25%"}}>
<CautionIcon  sx={{width:"15.9rem"}}/>
              </Box>

        <Box sx={{flex:"75%",display:"flex", flexDirection:"column", alignItems:"flex-start",justifyContent:"space-between"}}>
        <DialogContent sx={{ padding:"0"}}>
          <DialogContentText >
          {t(homeToken.GenericError)} 
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{padding:"0"}}>
          <Button  onClick={(e)=>{e.preventDefault();navigate("/web/connections");}} sx={{marginTop:"1.5rem",padding:'0.5rem 2rem',
    border: '2px solid #cf2030', color:'#cf2030','&:hover':{background:'#cf2030',color:'#f2f2f2'}}}>
            {t(homeToken.Home)}
          </Button>
        </DialogActions>
     
        </Box>
      </Box>
      </Box>
      </Dialog>

      </Container>
      </Box>
  );
};

export default PageNotFound;
